import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { HStack, VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';
import { TestSuiteDetailHeader } from './-components/TestSuiteDetailHeader';
export const Route = createFileRoute('/_stacktrace/test-suites/$id/_layout')({
  component: Layout
});
function TestSuiteDetailHeaderSkeleton() {
  return <VStack className="gap-4 bg-neutral-fill px-12 pt-4 shadow-xs">
      <HStack className="items-start justify-between gap-6">
        <HStack className="items-start gap-4 grow">
          <Skeleton className="size-12 shrink-0" />
          <VStack className="grow gap-2">
            <Skeleton className="h-6 w-32 rounded-full" />
            <Skeleton className="h-8 w-72" />
            <Skeleton className="h-5 w-96" />
          </VStack>
        </HStack>
        <HStack className="shrink-0 gap-2 pt-1">
          <Skeleton className="h-9 w-20 rounded-md" />
          <Skeleton className="h-9 w-28 rounded-md" />
        </HStack>
      </HStack>
      <Skeleton className="h-10 w-full" />
    </VStack>;
}
function Layout() {
  return <VStack>
      <Suspense fallback={<TestSuiteDetailHeaderSkeleton />}>
        <TestSuiteDetailHeader />
      </Suspense>
      <Suspense fallback={<div className="flex-1 px-12 py-5" />}>
        <Outlet />
      </Suspense>
    </VStack>;
}